module.exports = __webpack_public_path__ + "img/img_23.245f4274.svg";